// Ambulance
import AmbulanceBlack from './accessories/Ambulance svg/Ambulance black.png';
import AmbulanceBlue from './accessories/Ambulance svg/Ambulance Blue.png';
import AmbulanceGreen from './accessories/Ambulance svg/Ambulance Green.png';
import AmbulancePurple from './accessories/Ambulance svg/Ambulance purple.png';
import AmbulanceRed from './accessories/Ambulance svg/Ambulance Red.png';
import AmbulanceYellow from './accessories/Ambulance svg/Ambulance Yellow.png';

// Animal
import AnimalBlack from './accessories/animal svg/animal black.png';
import AnimalBlue from './accessories/animal svg/animal blue.png';
import AnimalGreen from './accessories/animal svg/animal green.png';
import AnimalPurple from './accessories/animal svg/animal purple.png';
import AnimalRed from './accessories/animal svg/animal red.png';
import AnimalYellow from './accessories/animal svg/animal yellow.png';

// Auto
import AutoBlack from './accessories/Auto svg/Auto black.png';
import AutoBlue from './accessories/Auto svg/Auto blue.png';
import AutoGreen from './accessories/Auto svg/Auto green.png';
import AutoPurple from './accessories/Auto svg/Auto purple.png';
import AutoRed from './accessories/Auto svg/Auto Red.png';
import AutoYellow from './accessories/Auto svg/Auto Yellow.png';

// Bike
import BikeBlack from './accessories/bike svg/Bike black.png';
import BikeBlue from './accessories/bike svg/Bike blue.png';
import BikeGreen from './accessories/bike svg/Bike green.png';
import BikePurple from './accessories/bike svg/bike purple.png';
import BikeRed from './accessories/bike svg/Bike red.png';
import BikeYellow from './accessories/bike svg/Bike yellow.png';

// Boat
import BoatBlack from './accessories/boat svg/boat black.png';
import BoatBlue from './accessories/boat svg/boat blue.png';
import BoatGreen from './accessories/boat svg/boat green.png';
import BoatPurple from './accessories/boat svg/boat purple.png';
import BoatRed from './accessories/boat svg/boat red.png';
import BoatYellow from './accessories/boat svg/boat yellow (1).png';

// Bulldozer
import BulldozerBlack from './accessories/Bulldozer svg/bulldozer black.png';
import BulldozerBlue from './accessories/Bulldozer svg/bulldozer blue.png';
import BulldozerGreen from './accessories/Bulldozer svg/bulldozer green.png';
import BulldozerPurple from './accessories/Bulldozer svg/bulldozer purple.png';
import BulldozerRed from './accessories/Bulldozer svg/bulldozer red.png';
import BulldozerYellow from './accessories/Bulldozer svg/bulldozer yellow.png';

// Bus
import BusBlack from './accessories/bus svg/bus black.png';
import BusBlue from './accessories/bus svg/bus blue.png';
import BusGreen from './accessories/bus svg/bus green.png';
import BusPurple from './accessories/bus svg/bus puple.png';
import BusRed from './accessories/bus svg/bus red.png';
import BusYellow from './accessories/bus svg/bus yellow.png';

// Car
import CarBlack from './accessories/car svg/Car black.png';
import CarBlue from './accessories/car svg/Car blue.png';
import CarGreen from './accessories/car svg/Car green.png';
// Purple car asset is not tracked in production, so reuse the blue variant as a safe fallback.
import CarPurple from './accessories/car svg/Car blue.png';
import CarRed from './accessories/car svg/Car Red.png';
import CarYellow from './accessories/car svg/Car yellow.png';

// Cat
import CatBlack from './accessories/cat svg/cat black.png';
import CatBlue from './accessories/cat svg/cat blue.png';
import CatGreen from './accessories/cat svg/cat green.png';
import CatPurple from './accessories/cat svg/cat purple.png';
import CatRed from './accessories/cat svg/cat red.png';
import CatYellow from './accessories/cat svg/cat yellow.png';

// Crane
import CraneBlack from './accessories/crane svg/crane black.png';
import CraneBlue from './accessories/crane svg/crane blue.png';
import CraneGreen from './accessories/crane svg/crane green.png';
import CranePurple from './accessories/crane svg/crane purple.png';
import CraneRed from './accessories/crane svg/crane red.png';
import CraneYellow from './accessories/crane svg/crane yellow.png';

// Dog
import DogBlack from './accessories/dog svg/dog black.png';
import DogBlue from './accessories/dog svg/dog blue.png';
import DogGreen from './accessories/dog svg/dog green.png';
import DogPurple from './accessories/dog svg/dog purple.png';
import DogRed from './accessories/dog svg/dog red.png';
import DogYellow from './accessories/dog svg/dog yellow.png';

// Dumpher
import DumpherBlack from './accessories/Dumpher svg/dumpher black.png';
import DumpherBlue from './accessories/Dumpher svg/dumpher blue.png';
import DumpherGreen from './accessories/Dumpher svg/dumpher green.png';
import DumpherPurple from './accessories/Dumpher svg/dumpher purple.png';
import DumpherRed from './accessories/Dumpher svg/dumpher red.png';
import DumpherYellow from './accessories/Dumpher svg/dumpher yellow.png';

// Female
import FemaleBlack from './accessories/female svg/female black.png';
import FemaleBlue from './accessories/female svg/female blue.png';
import FemaleGreen from './accessories/female svg/female green.png';
import FemalePurple from './accessories/female svg/female purple.png';
import FemaleRed from './accessories/female svg/female red.png';
import FemaleYellow from './accessories/female svg/female yellow.png';

// Female Child
import FemalechildBlack from './accessories/femalechild svg/femalechild black.png';
import FemalechildBlue from './accessories/femalechild svg/femalechild blue.png';
import FemalechildGreen from './accessories/femalechild svg/femalechild green.png';
import FemalechildPurple from './accessories/femalechild svg/femalechild purple.png';
import FemalechildRed from './accessories/femalechild svg/femalechild red.png';
import FemalechildYellow from './accessories/femalechild svg/femalechild yellow.png';

// JCB
import JcbBlack from './accessories/jcb svg/jcb black.png';
import JcbBlue from './accessories/jcb svg/jcb blue.png';
import JcbGreen from './accessories/jcb svg/jcb green.png';
import JcbPurple from './accessories/jcb svg/Jcb purple.png';
import JcbRed from './accessories/jcb svg/jcb red.png';
import JcbYellow from './accessories/jcb svg/jcb yellow.png';

// Luggage
import LaguageBlack from './accessories/luggage svg/laguage black.png';
import LuggageBlue from './accessories/luggage svg/luggage blue.png';
import LuggageGreen from './accessories/luggage svg/luggage green.png';
import LuggagePurple from './accessories/luggage svg/luggage purple.png';
import LuggageRed from './accessories/luggage svg/luggage red.png';
import LuggageYellow from './accessories/luggage svg/luggage yellow.png';

// Machine
import MachineBlack from './accessories/machine svg/machine black.png';
import MachineBlue from './accessories/machine svg/machine blue.png';
import MachineGreen from './accessories/machine svg/machine green.png';
import MachinePurple from './accessories/machine svg/machine purple.png';
import MachineRed from './accessories/machine svg/machine red.png';
import MachineYellow from './accessories/machine svg/machine yellow.png';

// Male
import MaleBlack from './accessories/male svg/male black.png';
import MaleBlue from './accessories/male svg/male blue.png';
import MaleGreen from './accessories/male svg/male green.png';
import MalePurple from './accessories/male svg/male purple.png';
import MaleRed from './accessories/male svg/male red.png';
import MaleYellow from './accessories/male svg/male yellow.png';

// Male Child
import MalechildBlack from './accessories/Malechild svg/malechild black.png';
import MalechildBlue from './accessories/Malechild svg/malechild blue.png';
import MalechildGreen from './accessories/Malechild svg/malechild green.png';
import MalechildPurple from './accessories/Malechild svg/malechild purple.png';
import MalechildRed from './accessories/Malechild svg/malechild red.png';
import MalechildYellow from './accessories/Malechild svg/malechild yelllow.png';

// Mixer
import MixerBlack from './accessories/mixer svg/mixer black.png';
import MixerBlue from './accessories/mixer svg/mixer blue.png';
import MixerGreen from './accessories/mixer svg/mixer green.png';
import MixerPurple from './accessories/mixer svg/mixer purple.png';
import MixerRed from './accessories/mixer svg/mixer red.png';
import MixerYellow from './accessories/mixer svg/mixer yellow.png';

// Pickup
import PickupBlack from './accessories/pickup svg/pickup black.png';
import PickupBlue from './accessories/pickup svg/pickup blue.png';
import PickupGreen from './accessories/pickup svg/pickup green.png';
import PickupPurple from './accessories/pickup svg/pickup purple.png';
import PickupRed from './accessories/pickup svg/pickup red.png';
import PickupYellow from './accessories/pickup svg/pickup yellow.png';

// Police Bike
import PolicebikeBlack from './accessories/policebike svg/policebike black.png';
import PolicebikeBlue from './accessories/policebike svg/policebike blue.png';
import PolicebikeGreen from './accessories/policebike svg/policebike green.png';
import PolicebikePurple from './accessories/policebike svg/policebike purple.png';
import PolicebikeRed from './accessories/policebike svg/policebike red.png';
import PolicebikeYellow from './accessories/policebike svg/policebike yellow.png';

// Police Bus
import PolicebusBlack from './accessories/policebus svg/policebus black.png';
import PolicebusBlue from './accessories/policebus svg/policebus blue.png';
import PolicebusGreen from './accessories/policebus svg/policebus green.png';
import PolicebusPurple from './accessories/policebus svg/policebus purple.png';
import PolicebusRed from './accessories/policebus svg/policebus red.png';
import PolicebusYellow from './accessories/policebus svg/policebus yellow.png';

// Police Car
import PolicecarBlack from './accessories/policecar svg/policecar black.png';
import PolicecarBlue from './accessories/policecar svg/policecar blue.png';
import PolicecarGreen from './accessories/policecar svg/policecar green.png';
import PolicecarPurple from './accessories/policecar svg/policecar purple.png';
import PolicecarRed from './accessories/policecar svg/policecar red.png';
import PolicecarYellow from './accessories/policecar svg/policecar yellow.png';

// Roadroller
import RoadrollerBlack from './accessories/roadroller svg/roadroller black.png';
import RoadrollerBlue from './accessories/roadroller svg/roadroller blue.png';
import RoadrollerGreen from './accessories/roadroller svg/roadroller green.png';
import RoadrollerPurple from './accessories/roadroller svg/roadroller purple.png';
import RoadrollerRed from './accessories/roadroller svg/roadroller red.png';
import RoadrollerYellow from './accessories/roadroller svg/roadroller yellow.png';

// School Bus
import SchoolbusBlack from './accessories/Schoolbus svg/schoolbus black.png';
import SchoolbusBlue from './accessories/Schoolbus svg/schoolbus blue.png';
import SchoolbusGreen from './accessories/Schoolbus svg/schoolbus green.png';
import SchoolbusPurple from './accessories/Schoolbus svg/schoolbus purple.png';
import SchoolbusRed from './accessories/Schoolbus svg/schoolbus red.png';
import SchoolbusYellow from './accessories/Schoolbus svg/schoolbus yellow.png';

// Scooty
import ScootyBlack from './accessories/scooty svg/scooty black.png';
import ScootyBlue from './accessories/scooty svg/scooty blue.png';
import ScootyGreen from './accessories/scooty svg/scooty green.png';
import ScootyPurple from './accessories/scooty svg/Scooty purple.png';
import ScootyRed from './accessories/scooty svg/scooty red.png';
import ScootyYellow from './accessories/scooty svg/scooty yellow.png';

// Tanker
import TankerBlack from './accessories/tanker svg/tanker black.png';
import TankerBlue from './accessories/tanker svg/tanker blue.png';
import TankerGreen from './accessories/tanker svg/tanker green.png';
import TankerPurple from './accessories/tanker svg/tanker purple.png';
import TankerRed from './accessories/tanker svg/tanker red.png';
import TankerYellow from './accessories/tanker svg/tanker yellow.png';

// Tractor
import TractorBlack from './accessories/Tracktor svg/Tracktor black.png';
import TractorBlue from './accessories/Tracktor svg/tracktor blue.png';
import TractorGreen from './accessories/Tracktor svg/Tracktor Green.png';
import TractorPurple from './accessories/Tracktor svg/Tracktor purple.png';
import TractorRed from './accessories/Tracktor svg/Tracktor Red.png';
import TractorYellow from './accessories/Tracktor svg/Tracktor Yellow.png';

// Truck
import TruckBlack from './accessories/Truck svg/Truck black.png';
import TruckBlue from './accessories/Truck svg/Truck blue.png';
import TruckGreen from './accessories/Truck svg/Truck green.png';
import TruckPurple from './accessories/Truck svg/truck purple.png';
import TruckRed from './accessories/Truck svg/truck red.png';
import TruckYellow from './accessories/Truck svg/Truck yellow.png';

// Van
import VanBlack from './accessories/van svg/van black.png';
import VanBlue from './accessories/van svg/van blue.png';
import VanGreen from './accessories/van svg/van green.png';
import VanPurple from './accessories/van svg/van purple.png';
import VanRed from './accessories/van svg/van red.png';
import VanYellow from './accessories/van svg/van yellow.png';

// Export all images organized by category
export const ambulanceImages = {
  black: AmbulanceBlack,
  blue: AmbulanceBlue,
  green: AmbulanceGreen,
  purple: AmbulancePurple,
  red: AmbulanceRed,
  yellow: AmbulanceYellow,
};

export const animalImages = {
  black: AnimalBlack,
  blue: AnimalBlue,
  green: AnimalGreen,
  purple: AnimalPurple,
  red: AnimalRed,
  yellow: AnimalYellow,
};

export const autoImages = {
  black: AutoBlack,
  blue: AutoBlue,
  green: AutoGreen,
  purple: AutoPurple,
  red: AutoRed,
  yellow: AutoYellow,
};

export const bikeImages = {
  black: BikeBlack,
  blue: BikeBlue,
  green: BikeGreen,
  purple: BikePurple,
  red: BikeRed,
  yellow: BikeYellow,
};

export const boatImages = {
  black: BoatBlack,
  blue: BoatBlue,
  green: BoatGreen,
  purple: BoatPurple,
  red: BoatRed,
  yellow: BoatYellow,
};

export const bulldozerImages = {
  black: BulldozerBlack,
  blue: BulldozerBlue,
  green: BulldozerGreen,
  purple: BulldozerPurple,
  red: BulldozerRed,
  yellow: BulldozerYellow,
};

export const busImages = {
  black: BusBlack,
  blue: BusBlue,
  green: BusGreen,
  purple: BusPurple,
  red: BusRed,
  yellow: BusYellow,
};

export const carImages = {
  black: CarBlack,
  blue: CarBlue,
  green: CarGreen,
  purple: CarPurple,
  red: CarRed,
  yellow: CarYellow,
};

export const catImages = {
  black: CatBlack,
  blue: CatBlue,
  green: CatGreen,
  purple: CatPurple,
  red: CatRed,
  yellow: CatYellow,
};

export const craneImages = {
  black: CraneBlack,
  blue: CraneBlue,
  green: CraneGreen,
  purple: CranePurple,
  red: CraneRed,
  yellow: CraneYellow,
};

export const dogImages = {
  black: DogBlack,
  blue: DogBlue,
  green: DogGreen,
  purple: DogPurple,
  red: DogRed,
  yellow: DogYellow,
};

export const dumpherImages = {
  black: DumpherBlack,
  blue: DumpherBlue,
  green: DumpherGreen,
  purple: DumpherPurple,
  red: DumpherRed,
  yellow: DumpherYellow,
};

export const femaleImages = {
  black: FemaleBlack,
  blue: FemaleBlue,
  green: FemaleGreen,
  purple: FemalePurple,
  red: FemaleRed,
  yellow: FemaleYellow,
};

export const femalechildImages = {
  black: FemalechildBlack,
  blue: FemalechildBlue,
  green: FemalechildGreen,
  purple: FemalechildPurple,
  red: FemalechildRed,
  yellow: FemalechildYellow,
};

export const jcbImages = {
  black: JcbBlack,
  blue: JcbBlue,
  green: JcbGreen,
  purple: JcbPurple,
  red: JcbRed,
  yellow: JcbYellow,
};

export const luggageImages = {
  black: LaguageBlack,
  blue: LuggageBlue,
  green: LuggageGreen,
  purple: LuggagePurple,
  red: LuggageRed,
  yellow: LuggageYellow,
};

export const machineImages = {
  black: MachineBlack,
  blue: MachineBlue,
  green: MachineGreen,
  purple: MachinePurple,
  red: MachineRed,
  yellow: MachineYellow,
};

export const maleImages = {
  black: MaleBlack,
  blue: MaleBlue,
  green: MaleGreen,
  purple: MalePurple,
  red: MaleRed,
  yellow: MaleYellow,
};

export const malechildImages = {
  black: MalechildBlack,
  blue: MalechildBlue,
  green: MalechildGreen,
  purple: MalechildPurple,
  red: MalechildRed,
  yellow: MalechildYellow,
};

export const mixerImages = {
  black: MixerBlack,
  blue: MixerBlue,
  green: MixerGreen,
  purple: MixerPurple,
  red: MixerRed,
  yellow: MixerYellow,
};

export const pickupImages = {
  black: PickupBlack,
  blue: PickupBlue,
  green: PickupGreen,
  purple: PickupPurple,
  red: PickupRed,
  yellow: PickupYellow,
};

export const policebikeImages = {
  black: PolicebikeBlack,
  blue: PolicebikeBlue,
  green: PolicebikeGreen,
  purple: PolicebikePurple,
  red: PolicebikeRed,
  yellow: PolicebikeYellow,
};

export const policebusImages = {
  black: PolicebusBlack,
  blue: PolicebusBlue,
  green: PolicebusGreen,
  purple: PolicebusPurple,
  red: PolicebusRed,
  yellow: PolicebusYellow,
};

export const policecarImages = {
  black: PolicecarBlack,
  blue: PolicecarBlue,
  green: PolicecarGreen,
  purple: PolicecarPurple,
  red: PolicecarRed,
  yellow: PolicecarYellow,
};

export const roadrollerImages = {
  black: RoadrollerBlack,
  blue: RoadrollerBlue,
  green: RoadrollerGreen,
  purple: RoadrollerPurple,
  red: RoadrollerRed,
  yellow: RoadrollerYellow,
};

export const schoolbusImages = {
  black: SchoolbusBlack,
  blue: SchoolbusBlue,
  green: SchoolbusGreen,
  purple: SchoolbusPurple,
  red: SchoolbusRed,
  yellow: SchoolbusYellow,
};

export const scootyImages = {
  black: ScootyBlack,
  blue: ScootyBlue,
  green: ScootyGreen,
  purple: ScootyPurple,
  red: ScootyRed,
  yellow: ScootyYellow,
};

export const tankerImages = {
  black: TankerBlack,
  blue: TankerBlue,
  green: TankerGreen,
  purple: TankerPurple,
  red: TankerRed,
  yellow: TankerYellow,
};

export const tractorImages = {
  black: TractorBlack,
  blue: TractorBlue,
  green: TractorGreen,
  purple: TractorPurple,
  red: TractorRed,
  yellow: TractorYellow,
};

export const truckImages = {
  black: TruckBlack,
  blue: TruckBlue,
  green: TruckGreen,
  purple: TruckPurple,
  red: TruckRed,
  yellow: TruckYellow,
};

export const vanImages = {
  black: VanBlack,
  blue: VanBlue,
  green: VanGreen,
  purple: VanPurple,
  red: VanRed,
  yellow: VanYellow,
};

// Export all images in one object for easy access
export const allImages = {
  ambulance: ambulanceImages,
  animal: animalImages,
  auto: autoImages,
  bike: bikeImages,
  boat: boatImages,
  bulldozer: bulldozerImages,
  bus: busImages,
  car: carImages,
  cat: catImages,
  crane: craneImages,
  dog: dogImages,
  dumpher: dumpherImages,
  female: femaleImages,
  femalechild: femalechildImages,
  jcb: jcbImages,
  luggage: luggageImages,
  machine: machineImages,
  male: maleImages,
  malechild: malechildImages,
  mixer: mixerImages,
  pickup: pickupImages,
  policebike: policebikeImages,
  policebus: policebusImages,
  policecar: policecarImages,
  roadroller: roadrollerImages,
  schoolbus: schoolbusImages,
  scooty: scootyImages,
  tanker: tankerImages,
  tractor: tractorImages,
  truck: truckImages,
  van: vanImages,
};
